import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getImage } from "@public/ulits";
import ToggleVisible from "@components/ToggleVisible";
import headerState from "@public/states/headerState";
import { MenuOutlined } from "@ant-design/icons";
import LangSwitch from "@components/LangSwitch";

export default ({ bgColor = "rgba(22,34,56,0.6)" }) => {
    let { navs, menuOpen, setMenuOpen } = headerState();
    const location = useLocation();
    const isActive = (route) => {
        if (route === '/') return location.pathname === '/';
        return location.pathname.startsWith(route);
    };
    return (
        <div className="flex justify-between items-center px-[40px] py-4 fixed left-0 top-0 z-10 w-full" style={{ backgroundColor: bgColor }}>
            <Link to="/"><img className="logo lg:w-16 h-auto w-8" src={getImage("logo-notext.svg")} /></Link>
            <ul className={`lg:navs lg:flex lg:static lg:w-auto lg:text-left absolute w-[60%] right-0 bg-[rgba(0,0,0,0.6)] lg:bg-transparent top-[100%] text-right ${menuOpen ? 'block' : 'hidden'} text-[#d7dfec]`}>
                {
                    navs.map((nav, index) => (
                        <>
                            <hr className={`bg-white`} />
                            {nav.route ? (
                                <Link to={nav.route} onClick={() => setMenuOpen(false)}>
                                    <li className={`lg:py-0 nav-item lg:text-2xl text-sm px-4 cursor-pointer py-2 transition-colors ${isActive(nav.route) ? 'text-gold' : 'hover:text-gold'}`}>{nav.name}</li>
                                </Link>
                            ) : nav.isButton ? (
                                <a href={nav.link} target={`_blank`}>
                                    <li className="lg:py-0 px-4 py-2">
                                        <button className="btn-login rounded-full px-6 py-2 text-white font-bold text-base cursor-pointer border-none">{nav.name}</button>
                                    </li>
                                </a>
                            ) : nav.link ? (
                                <a href={nav.link} target={`_blank`}>
                                    <li className="lg:py-0 nav-item lg:text-2xl text-sm  px-4 cursor-pointer py-2 hover:text-gold transition-colors">{nav.name}</li>
                                </a>
                            ) : (
                                <li className="lg:py-0 nav-item lg:text-2xl text-sm  px-4 py-2 hover:text-gold transition-colors">{nav.name}</li>
                            )}
                            <ToggleVisible visible={index < navs.length - 1}>
                                <li className={`hidden items-center lg:flex`}>|</li>
                            </ToggleVisible>
                        </>
                    ))
                }
            </ul>
            <div className="flex items-center gap-3">
                <LangSwitch />
                <MenuOutlined className={`text-white text-3xl  lg:hidden`} onClick={e => setMenuOpen(!menuOpen)} />
            </div>
        </div>
    );
};
